import React from 'react';
import Banner from '../../prelogin/src/components/Banner';
import UserLoginType from './sg_UserLoginType';
import Whatsapp from '../login/Whatsapp.js';
import ModalVideo from 'react-modal-video';

/*
* This class is merely an extension of the previous banner
*
*/
export default class sg_Banner extends Banner{
	
	homeforweb(){

		  return (
			<div className="slider-inner b-web-comp" style={{padding:'40px 0px'}}>
			<div  className="col-12 b-right" style={{display:'none'}}>
				<div className="r-banner">
					<img src="../img/banner1.png" alt="" onClick={this.openModal}/>
					<a data-ga="Home  - Hey Parent Video" className="popup-modal" onClick={this.openModal}><span className="play-btn"></span></a>
				</div>
			</div>
			<div className="col-12 slider-inner-shadow">
			
				<h1 className="heading-one" style={{textAlign:'center'}}>
					<span className="txtcnt first-line" style={{fontSize:'32px'}}>{this.rb("banner.heading.2")}</span> 
					<span className="txtcnt furtxt" style={{fontSize:'32px'}}>{this.rb("banner.subheading.2")}</span>
				</h1>
				<h1 className="heading-one" style={{textAlign:'center',marginBottom:'20px'}}>
				<span className="txtcnt furtxt" style={{fontSize:'32px'}}>{this.rb("banner.subheading1.2")}</span>
				</h1>

				{/* <div className="heading-one robotospan" style={{textAlign:'center'}}>
				<span className="txtcnt first-line" style={{fontSize:'24px'}}>{this.rb("banner.subheading1.3")}</span>
				<span className="txtcnt furtxt" style={{fontSize:'24px'}}>{this.rb("banner.subheading1.4")}</span>
				</div> */}
						
				{(() => {

					if(!this.props.PLPloggedIn){ 
						const styles={
							margin:'0 auto'
						}

						return(
								
								<div className="col-12 nopadding mx-auto joingrp">
									<UserLoginType styles={styles} showSignUp={this.props.showSignUp} showNewLoginForm={this.props.showNewLoginForm} from={"Top"}/>
									{/* <Whatsapp align="center" maxWidth="100%">/</Whatsapp> */}
								</div>
								
						);
					}
				})()}	
			</div> 
			</div>
		  )
	  }


	  homeformobile(){
	 
		return (
			<div className="comp-inner">
			
			<div className="col-12 text-center b-comp">
			

				<div>
				<div><span className="txtcnt">{this.rb("banner.heading.2")}</span></div> 
				<div>
					<span className="txtcnt furtxt">{this.rb("banner.subheading.2")}</span>
					<span className="txtcnt furtxt">{this.rb("banner.subheading1.2")}</span>
				</div>
				</div>

				{/* <div>
				<h1 className="heading-one" style={{textAlign:'center'}}>
					<span className="txtcnt first-line" style={{fontSize:'32px'}}>{this.rb("banner.heading.2")}</span> 
					<span className="txtcnt furtxt" style={{fontSize:'32px'}}>{this.rb("banner.subheading.2")}</span>
				</h1>
				<h1 className="heading-one" style={{textAlign:'center',marginBottom:'20px'}}>
				<span className="txtcnt furtxt" style={{fontSize:'32px'}}>{this.rb("banner.subheading1.2")}</span>
				</h1>
				</div> */}


				{(() => {
					if(!this.props.PLPloggedIn){ 
						return(
								<div className="col-12 nopadding mx-auto joingrp">
									<UserLoginType showSignUp={this.props.showSignUp} showNewLoginForm={this.props.showNewLoginForm} from={"Top"}/>
									{/* <Whatsapp align="center" background={"#30BDBD"} maxWidth="100%">/</Whatsapp> */}
								</div>
						);
					}
				})()}		
			</div> 
			</div>
		  ) 
	  }

	  homecomponent(){
		if(this.isMobile() || this.isTab()){
			return (
				<section className="h-mob-banner">  
					<div className="swiper-container home-banner"> 
						{/*<Swiper className="swiper-wrapper" pagination={params.pagination}>*/} 
							<div className="swiper-slide"> 
								<div className="container">
									{this.homeformobile()}
								</div>
								</div>
							
						{/*</Swiper>*/} 
						<div className="swiper-pagination"></div>
					</div>
					<ModalVideo channel='youtube' isOpen={this.state.isOpen} videoId='b-X5TsIQG24' onClose={() => this.setState({isOpen: false})} />  
				</section>
			)
			
		}else{
			return(
				<section className="h-banner">  
					<div className="swiper-container home-bannerweb"> 
						{/*<Swiper className="swiper-wrapper" pagination={params.pagination}>*/} 
							<div className="swiper-slide"> 
								<div className="container">
									{this.homeforweb()}
								</div>
								</div>
							
						{/*</Swiper>*/} 
						<div className="swiper-pagination"></div>
					</div>
					<ModalVideo channel='youtube' isOpen={this.state.isOpen} videoId='b-X5TsIQG24' onClose={() => this.setState({isOpen: false})} />  
				</section>

			)
		}
	}

}



// WEBPACK FOOTER //
// ./src/views/sg/sg_Banner.js